<template>
<div>
    <div class="columns" style="border: 1px solid #CCC;" v-show="!isEditing">
        <div class="column is-three-quarters">
          <p class="subtitle">
            {{ data.firstName }} {{ data.lastName }} 
          </p>
        </div>
        <div class="column is-one-quarter">
          <div class="field has-addons" style="float: right">
            <div class='extra content'>                
              <!-- <span class='right floated edit icon' v-on:click="showQR(data)">
                <font-awesome-icon icon="qrcode" class="icon" />
              </span> -->
              <span class='right floated edit icon' v-on:click="showForm">
                <font-awesome-icon icon="edit" />
              </span>
              <span class='right floated trash icon' v-on:click="deleteData(data)">
                <font-awesome-icon icon="trash-alt" />
              </span>
            </div>
          </div>
        </div>
    </div>
    <div class="columns" style="border: 1px solid #CCC; padding: 10px;" v-show="isEditing">
        <div class="column">            
            <div class="field">
                <label class="label">Choose Class</label>
                <div class="control">
                    <b-select id="kelasID" name="kelasID" v-model="data.kelasID">
                        <option value="0">Select the class</option>
                        <option v-for="kelas in kelasList" v-bind:value="kelas._id" v-bind:key="kelas._id">{{ kelas.level }} {{ kelas.name }}</option>
                    </b-select>
                </div>
            </div>
            <div class="field">
                <label class="label">First Name</label>
                <div class="control">
                    <input class="input" type="text" placeholder="E.g.: Bruce" v-model="data.firstName">
                </div>
            </div>
            <div class="field">
                <label class="label">Last Name</label>
                <div class="control">
                    <input class="input" type="text" placeholder="E.g.: Wayne" v-model="data.lastName">
                </div>
            </div>
        <div class="field">
            <label class="label">Father's Name</label>
            <div class="control">
                <input class="input" type="text" placeholder="E.g.: Father's Name" v-model="data.father">
            </div>
        </div>
        <div class="field">
            <label class="label">Father's ID</label>
            <div class="control">
                <input class="input" type="text" placeholder="E.g.: Father's ID" v-model="data.fatherID">
            </div>
        </div>
        <div class="field">
            <label class="label">Mother's Name</label>
            <div class="control">
                <input class="input" type="text" placeholder="E.g.: Mother's Name" v-model="data.mother">
            </div>
        </div>
        <div class="field">
            <label class="label">Mother's ID</label>
            <div class="control">
                <input class="input" type="text" placeholder="E.g.: Mother's ID" v-model="data.motherID">
            </div>
        </div>
            <div class="field">
                <label class="label">Contact No #1</label>
                <div class="control">
                    <input class="input" type="text" placeholder="E.g.: Telephone Number" v-model="data.contactNo1">
                </div>
        </div>
            <div class="field">
                <label class="label">&nbsp;</label>
                    <div class='ui two buttons'>
                        <button class='ui blue button' v-on:click="hideForm(data)">OK</button>
                    </div>
            </div>
        </div>
    </div>
      <!-- <div class="columns" style="border: 1px solid #CCC;" v-show="isEditing">
          <div class="column">
              <div class="content">
                  <div class="field has-addons">
                      <p class="control">
                          <input class="input" type="text" placeholder="Level, eg: 1" v-model="data.firstName" name="updateLevel">
                      </p>
                      <p class="control">
                        <input class="input" type="text" placeholder="Class Name, eg: Fatonah" v-model="data.lastName" name="updateName">
                      </p>
                      <p class="control">
                        <button class='ui blue button' v-on:click="hideForm(data)">OK</button>
                      </p>
                  </div>
              </div>
          </div>
      </div> -->
</div>
</template>

<script>
import axios from 'axios'
import VueQr from 'vue-qr'
export default {
    props: ['data'],
    data() {
        return {
            // data: {
            //     kelasID : '0'
            // },
            kelasList: [],
            isEditing: false,
        };
    },
    created() {
        axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
        axios.post(process.env.MY_URL + '/api/auth/kelas/list', {
            params: {
                email: localStorage.getItem('email')
            }
        })
        .then(response => {
        // JSON responses are automatically parsed.
            this.kelasList = response.data
        })
        .catch(e => {
            this.errors.push(e)
            console.log(e)
        })
    },
    methods: {
        completeData(data) {
            this.$emit('complete-data', data);
        },
        deleteData(data) {
            this.$emit('delete-data', data);
        },
        showForm() {
            this.isEditing = true;
        },
        hideForm(data) {
            this.$emit('update-data', data);

            this.isEditing = false;
        },
        showQR(data) {
            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'blob'
            axios.post(process.env.MY_URL + '/api/students/qr', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID'),
                        dataID: data._id
                    }
                })
                .then(response => {                    
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', data._id + '.png'); //or any other extension
                    document.body.appendChild(link);
                    link.click();

                    // let blob = new Blob([response.data], { type: 'application/pdf' }),
                    // url = window.URL.createObjectURL(blob)

                    //     window.open(url) 

                    // this.dataList = response.data
                    // console.log(this.dataList)
                })
                .catch(e => {
                    this.errors.push(e)
                    console.log(e)
                })
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Students/DataView.vue